import React from 'react'
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom'
import UpgradeModal from 'components/upgrade-modal'
import { flags, useFeatureFlags } from 'lib/feature-flags'
import CampaignList from './campaign-list'
import CampaignResults from './campaign-results'
import CampaignWizard from './campaign-wizard'
import { PAGE_NAME } from './constants'

const CampaignsPage = () => {
  const { path } = useRouteMatch()
  const [isCoachCampaignsEnabled] = useFeatureFlags([
    flags.FLAG_FEAT_COACH_CAMPAIGNS,
  ])

  if (!isCoachCampaignsEnabled) return <Redirect to="/pga-coach" />

  return (
    <UpgradeModal
      pageName={PAGE_NAME}
      title="Send Campaigns With PGA Coach+"
      description="Message a group of your students at once about openings, clinics, and programs. See who read it, replied, and booked."
    >
      <Switch>
        <Route exact path={path} component={CampaignList} />
        <Route exact path={`${path}/new`} component={CampaignWizard} />
        <Route exact path={`${path}/:id/edit`} component={CampaignWizard} />
        <Route exact path={`${path}/:id`} component={CampaignResults} />
      </Switch>
    </UpgradeModal>
  )
}

export default CampaignsPage
